import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

const InfoPackingListText = ({ selectedParcels }) => {
  const { t } = useTranslation()

  return (
    <>
      <Text type="bodyMRegular">
        {selectedParcels?.length === 1
          ? t('Estás a punto de generar la lista de empaquetado para 1 envío')
          : t('Estás a punto de generar la lista de empaquetado para {{count}} envíos', {
              count: selectedParcels?.length,
            })}
      </Text>
      <Text type="bodyMRegular">
        {t('Este proceso puede tardar unos momentos. Por favor, ten paciencia mientras se completa.')}
      </Text>
    </>
  )
}

export default InfoPackingListText
